import { PrivateRoute } from 'app/routes';
import { useSchool } from 'features/school';
import { ReactElement, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const EducationalLayout = (): ReactElement => {
  const {
    features: { hasEducationalInstitution },
  } = useSchool();

  useEffect(() => {
    if (!hasEducationalInstitution) {
      window.location.href = '/login';
    }
  }, [hasEducationalInstitution]);

  return (
    <>
      <PrivateRoute redirectIfNotLogged={false}>
        <Outlet />
      </PrivateRoute>
    </>
  );
};

export default EducationalLayout;
